<ng-container *ngIf="items.length > 0">
  <div class="submenu-level-2">
    <ul nz-menu [nzMode]="'horizontal'">
      <ng-container *ngFor="let item of items">
        <ng-container *ngIf="hasAccess(item); else disabledLink">
          <li class="ant-menu-item ng-star-inserted" routerLinkActive="ant-menu-item-selected">
            <a routerLink="{{ item.url }}" title="{{ item.title }}">
              <span class="title">{{ item.title }}</span>
            </a>
          </li>
        </ng-container>
        <ng-template #disabledLink>
          <li class="ant-menu-item ng-star-inserted">
            <a title="{{ item.title }}" class="disabled">
              <span class="title">{{ item.title }}</span>
            </a>
          </li>
        </ng-template>
      </ng-container>
    </ul>
  </div>
</ng-container>
